module.exports = __webpack_public_path__ + "static/media/border-lights.7e5bb1dd.png";